import { useLayoutEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSettingsHub } from "@/shell/settings-hub";

/** 예전 주소는 설정 MCP로 연다. */
export function McpConnectionPage() {
  useLayoutEffect(() => {
    useSettingsHub.getState().open("app", "integration");
  }, []);
  return <Navigate to="/" replace />;
}
